export default "__VITE_PUBLIC_ASSET__948ae67d__"